import {
  Box,
  IconChevron,
  MenuItem,
  MenuRenderer,
  Text,
} from 'braid-design-system';
import { Underline } from '../Underline/Underline.tsx';
import { useMemo } from 'react';

export function SmallBoldUnderlinedTextDropdown<T = string>({
  options,
  value,
  setValue,
}: {
  options: Array<{ label: string; value: T }>;
  setValue: (value: T) => void;
  value: T;
}) {
  const labelMap = useMemo(
    () =>
      new Map(
        options.map(({ label, value: optionValue }) => [optionValue, label]),
      ),
    [options],
  );

  return (
    <MenuRenderer
      align="left"
      offsetSpace="small"
      trigger={(triggerProps, { open }) => (
        <Box userSelect="none" cursor="pointer" {...triggerProps}>
          <Text size="small" weight="strong">
            <Underline>
              {labelMap.get(value)}{' '}
              <IconChevron
                direction={open ? 'up' : 'down'}
                alignY="lowercase"
              />
            </Underline>
          </Text>
        </Box>
      )}
    >
      {options.map(({ label, value: optionValue }) => (
        <MenuItem key={`${optionValue}`} onClick={() => setValue(optionValue)}>
          {label}
        </MenuItem>
      ))}
    </MenuRenderer>
  );
}
